export const useIntercom = () => {
  const intercomSelector = '.intercom-lightweight-app';

  // Opens Intercom chat window
  const showIntercom = () => {
    if (window.Intercom != null) {
      window.Intercom('show');
    }
  };

  const showIntercomLauncher = () => {
    if (window.Intercom != null) {
      window.Intercom('update', { hide_default_launcher: false });
    }
  };

  const hideIntercomLauncher = () => {
    if (window.Intercom != null) {
      window.Intercom('update', { hide_default_launcher: true });
    }
  };

  const showMessage = (message: string) => {
    if (window.Intercom != null) {
      window.Intercom('showNewMessage', message);
    }
  };

  return {
    showIntercomLauncher,
    showIntercom,
    hideIntercomLauncher,
    showMessage,
    intercomSelector,
  };
};
